export default __webpack_public_path__ + "static/media/LEISURE.9a890bf1.jpg";